/* =====================================================================
 * GlobalRuntimeHost — workspace-wide effects and global overlays.
 *
 * This host intentionally renders no page layout. It keeps process-level
 * runtime concerns alive while route elements choose their own page shell.
 * ===================================================================== */

import React, { Suspense, useEffect } from 'react';
import {
  initializeWorkspaceEffects,
  onAppEvent,
  useUIStore,
} from '@auw/stores';
import { getSettingsModalComponent } from '@auw/workspace-ui';

export const GlobalRuntimeHost: React.FC = () => {
  // Samsung 단일 사용자 어시스턴트: mode.message 비활성 → DM WebSocket /
  // realtime 큐 자체를 띄우지 않는다.
  const settingsModalOpen = useUIStore((s) => s.settingsModalOpen);
  const settingsModalRequest = useUIStore((s) => s.settingsModalRequest);
  const setSettingsModalOpen = useUIStore((s) => s.setSettingsModalOpen);
  const openSettingsModal = useUIStore((s) => s.openSettingsModal);

  useEffect(() => {
    return initializeWorkspaceEffects({ messageEnabled: false });
  }, []);

  useEffect(() => {
    return onAppEvent('app:openSettings', (detail) => openSettingsModal(detail));
  }, [openSettingsModal]);

  return (
    <Suspense fallback={null}>
      {(() => {
        const SettingsModalComp = getSettingsModalComponent();
        if (!SettingsModalComp) return null;
        return (
          <SettingsModalComp
            open={settingsModalOpen}
            initialTab={settingsModalRequest?.initialTab}
            focusSection={settingsModalRequest?.focusSection}
            requestId={settingsModalRequest?.requestId ?? 0}
            onClose={() => setSettingsModalOpen(false)}
          />
        );
      })()}
    </Suspense>
  );
};
